<template>
  <div id="loan">
    <loading v-if="loadingRender"></loading>

    <panel
      class="no-print"
      :Title="$GetIsAnbohSaz() == 'false' ? 'لیست تسهیلات' : 'لیست قراردادها'"
      :Des="
        $GetIsAnbohSaz() == 'false'
          ? 'از طریق این فرم می توانید لیست تسهیلات های خود را مشاهده واز امکانات عملیات های پرداخت قسط و کاردکس تسهیلات استتفاده کنید'
          : 'از طریق این فرم می توانید لیست قراردادهای خود را مشاهده کنید'
      "
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-tab class="no-print" :Tabs="LoanTabs">
      <net-pa-view-toggle
        :value="IsShowCard"
        :show-list="$GetIsAnbohSaz() == 'false'"
        :aria-label="
          $GetIsAnbohSaz() == 'false'
            ? 'نوع نمایش تسهیلات'
            : 'نوع نمایش قراردادها'
        "
        @input="ShowCard"
      ></net-pa-view-toggle>
    </net-pa-tab>
    <net-pa-card class="no-print" :Compact="true">
      <template slot="content">
        <div class="tab-content text-right p-3" id="Controler">
          <div
            class="tab-pane fade show active loan-own"
            id="Detailtab"
            role="tabpanel"
            aria-labelledby="Detailtab-tab"
          >
            <div class="loan-own-body">
              <div class="loan-own-toolbar">
                <net-pa-filter-dropdown
                  :button-id="'loanFilterButton'"
                  :label="
                    $GetIsAnbohSaz() == 'false'
                      ? 'فیلتر تسهیلات'
                      : 'فیلتر قرارداد ها'
                  "
                >
                  <a
                    class="dropdown-item"
                    href="Javascript:;"
                    @click="
                      GetItemCard(false);
                      $ResetTimer();
                    "
                  >
                    {{
                      $GetIsAnbohSaz() == "false"
                        ? "تسهیلات دارای بدهی"
                        : "قرارداد های داری بدهی"
                    }}
                    <i
                      v-if="selectedBedehi && selectedAllBedehi == false"
                      class="fas fa-check text-success"
                    ></i>
                  </a>
                  <a
                    class="dropdown-item"
                    href="Javascript:;"
                    @click="
                      GetItemCard(true);
                      $ResetTimer();
                    "
                  >
                    {{
                      $GetIsAnbohSaz() == "false"
                        ? "همه تسهیلات"
                        : "همه قرارداد ها"
                    }}
                    <i
                      v-if="selectedAllBedehi && selectedBedehi == false"
                      class="fas fa-check text-success"
                    ></i>
                  </a>
                </net-pa-filter-dropdown>
              </div>

              <div
                v-if="CardItem && CardItem.length > 0 && IsShowCard"
                class="loan-own-grid"
              >
                <div
                  class="loan-own-card-col"
                  v-for="(item, index) in CardItem"
                  :key="item.id || index"
                >
                  <div class="loan-own-card" dir="rtl">
                    <div class="loan-own-card__toolbar">
                      <div class="loan-own-card__tools">
                        <router-link
                          class="loan-own-icon-btn"
                          title="گردش تسهیلات"
                          :to="{
                            name: 'Turnover',
                            params: {
                              TaahodatId: item.id,
                              wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                              wwwtblAzaId: item.wwwtblAzaId,
                            },
                          }"
                        >
                          <i class="fas fa-list" aria-hidden="true"></i>
                        </router-link>
                        <a
                          v-if="
                            $session.get('CustCode') != 868 &&
                            $GetIsAnbohSaz() == 'false'
                          "
                          class="loan-own-icon-btn"
                          data-toggle="modal"
                          data-target="#Modal-Mobile"
                          @click="OpenDetail(index)"
                          title="جزئیات تسهیلات"
                        >
                          <i
                            class="fas fa-info-circle Pointer"
                            aria-hidden="true"
                          ></i>
                        </a>
                        <a
                          v-if="$session.get('CustCode') == 868"
                          data-toggle="modal"
                          data-target="#Modal-Mobile"
                          @click="OpenDetail(index)"
                          title="جزئیات تسهیلات"
                          class="loan-own-chip loan-own-chip--info Pointer"
                        >
                          جزئیات تسهیلات
                        </a>
                        <a
                          href="javascript:;"
                          class="loan-own-icon-btn"
                          title="افزودن به لیست پرداخت"
                          @click="AddToCart(item, false)"
                          :class="{
                            'd-none':
                              item.mande.replaceAll(',', '') +
                                Number(item.wwwJarime) -
                                item.sumMabTaeedNaShode.replaceAll(',', '') <=
                              0,
                          }"
                        >
                          <i class="fas fa-cart-plus" aria-hidden="true"></i>
                        </a>
                      </div>
                      <div class="loan-own-card__tools">
                        <button
                          v-if="$session.get('CustCode') == '945'"
                          type="button"
                          class="loan-own-chip loan-own-chip--muted Pointer"
                          @click="DownloadFishVariz(item)"
                        >
                          <i class="fas fa-receipt ml-1" aria-hidden="true"></i>
                          دانلود فیش
                        </button>
                        <button
                          v-if="item.shenaseVariz"
                          type="button"
                          class="loan-own-icon-btn"
                          title="اشتراک‌گذاری لینک پرداخت"
                          @click="sharePaymentLink(item)"
                        >
                          <i class="fas fa-share-alt" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>

                    <div class="loan-own-card__fields">
                      <div class="loan-own-field">
                        <span class="loan-own-field__label">
                          {{
                            $GetIsAnbohSaz() == "false"
                              ? "نوع تسهیلات"
                              : "نوع قرارداد"
                          }}
                        </span>
                        <span class="loan-own-field__value">
                          {{ item.desNoe }}
                        </span>
                      </div>
                      <div class="loan-own-field">
                        <span class="loan-own-field__label">
                          {{
                            $GetIsAnbohSaz() == "false"
                              ? "شماره تسهیلات"
                              : "شماره قرارداد"
                          }}
                        </span>
                        <span class="loan-own-field__value" dir="rtl">
                          {{ item.vCode }}
                        </span>
                      </div>
                      <div class="loan-own-field">
                        <span class="loan-own-field__label"
                          >تاریخ شروع اقساط</span
                        >
                        <span class="loan-own-field__value">
                          {{ item.tarixShoroAghsat }}
                        </span>
                      </div>
                      <div class="loan-own-field">
                        <span class="loan-own-field__label">
                          {{
                            $GetIsAnbohSaz() == "false"
                              ? "مبلغ تسهیلات"
                              : "مبلغ واحد"
                          }}
                        </span>
                        <span class="loan-own-field__value">
                          {{ $Comma3ragham(item.mablaghVam) }}
                        </span>
                      </div>
                      <div class="loan-own-field">
                        <span class="loan-own-field__label">شناسه واریز</span>
                        <span class="loan-own-field__value">
                          {{ item.shenaseVariz }}
                        </span>
                      </div>
                      <div class="loan-own-field loan-own-field--danger">
                        <span class="loan-own-field__label">
                          مجموع معوق
                          <i
                            v-if="
                              Number(
                                item.sumMabMoavaghe
                                  .replace(/,/g, '')
                                  .replace(/\./g, ''),
                              ) > 0 &&
                              ($session.get('CustCode') == 945 ||
                                $session.get('CustCode') == 8002)
                            "
                            class="fas fa-info-circle text-warning Pointer mr-1"
                            title="جزئیات معوقات"
                            data-toggle="modal"
                            data-target="#ModalBanafash"
                            @click="
                              TaahodatIdForCardex = item.id;
                              wwwtblAzaIdForCardex = item.wwwtblAzaId;
                              moavagheModalSubtitle =
                                item.desNoe + ' — ' + item.vCode;
                            "
                          ></i>
                        </span>
                        <span class="loan-own-field__value">
                          {{
                            $Comma3ragham(item.sumMabMoavaghe) == "null"
                              ? "-"
                              : $Comma3ragham(item.sumMabMoavaghe)
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="loan-own-balance">
                      <div class="loan-own-balance__row">
                        <span class="loan-own-balance__label">مبلغ قسط</span>
                        <span class="loan-own-balance__value">
                          {{ $Comma3ragham(item.mablaghGhestVam) }}
                        </span>
                      </div>
                      <div class="loan-own-balance__row">
                        <span class="loan-own-balance__label">
                          {{
                            $GetIsAnbohSaz() == "false"
                              ? "مانده تسهیلات"
                              : "مانده قرارداد"
                          }}
                        </span>
                        <span class="loan-own-balance__value">
                          {{
                            $Comma3ragham(
                              Number(item.ghabelBardasht.replaceAll(",", "")),
                            )
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="loan-own-actions">
                      <a
                        v-if="
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 11)[0].isMenu
                        "
                        @click="Deposit(item, tasveye(item.id))"
                        :class="{
                          disabled:
                            item.mande.replaceAll(',', '') +
                              Number(item.wwwJarime) -
                              item.sumMabTaeedNaShode.replaceAll(',', '') <=
                            0,
                        }"
                        class="loan-own-chip loan-own-chip--deposit Pointer"
                      >
                        پرداخت
                      </a>
                      <router-link
                        :to="{
                          name: 'LoanCardex',
                          params: {
                            TaahodatId: item.id,
                            wwwtblAzaId: item.wwwtblAzaId,
                          },
                        }"
                        :class="{
                          disabled: item.mande.replaceAll(',', '') <= 0,
                        }"
                        class="loan-own-chip loan-own-chip--ghost"
                      >
                        {{
                          $GetIsAnbohSaz() == "false"
                            ? "کاردکس"
                            : "کاردکس اقساط"
                        }}
                      </router-link>
                      <router-link
                        title="گردش تسهیلات"
                        :to="{
                          name: 'Turnover',
                          params: {
                            TaahodatId: item.id,
                            wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                            wwwtblAzaId: item.wwwtblAzaId,
                          },
                        }"
                        class="loan-own-chip loan-own-chip--turn"
                      >
                        گردش تسهیلات
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="IsShowCard && (!CardItem || CardItem.length < 1)"
                class="loan-own-empty"
              >
                {{
                  $GetIsAnbohSaz() == "false"
                    ? "تسهیلاتی برای نمایش یافت نشد"
                    : "قراردادی برای نمایش یافت نشد"
                }}
              </div>

              <div v-if="!IsShowCard" class="loan-own-list accounts-list-view">
                <vue-bootstrap4-table
                  :rows="rows"
                  :columns="columns"
                  :config="config"
                  :classes="classes"
                >
                  <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                  </template>
                  <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                  </template>
                  <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                  </template>
                  <template slot="action-slot" slot-scope="props">
                    <div class="loan-own-list-actions">
                      <a
                        v-if="
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 11)[0].isMenu
                        "
                        @click="Deposit(props.row, tasveye(props.row.id))"
                        :class="{
                          disabled:
                            props.row.mande.replaceAll(',', '') +
                              Number(props.row.wwwJarime) -
                              props.row.sumMabTaeedNaShode.replaceAll(
                                ',',
                                '',
                              ) <=
                            0,
                        }"
                        class="loan-own-chip loan-own-chip--deposit Pointer"
                        >پرداخت</a
                      >
                      <a
                        href="javascript:;"
                        title="افزودن به لیست پرداخت"
                        @click="AddToCart(props.row, false)"
                        :class="{
                          'd-none':
                            props.row.mande.replaceAll(',', '') +
                              Number(props.row.wwwJarime) -
                              props.row.sumMabTaeedNaShode.replaceAll(
                                ',',
                                '',
                              ) <=
                            0,
                        }"
                        class="loan-own-chip loan-own-chip--withdraw Pointer"
                      >
                        <i class="fas fa-cart-plus ml-1" aria-hidden="true"></i
                        >افزودن
                      </a>
                      <router-link
                        title="گردش تسهیلات"
                        :to="{
                          name: 'Turnover',
                          params: {
                            TaahodatId: props.row.id,
                            wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                            wwwtblAzaId: props.row.wwwtblAzaId,
                          },
                        }"
                        class="loan-own-chip loan-own-chip--turn"
                      >
                        گردش تسهیلات
                      </router-link>
                      <router-link
                        :to="{
                          name: 'LoanCardex',
                          params: {
                            TaahodatId: props.row.id,
                            wwwtblAzaId: props.row.wwwtblAzaId,
                          },
                        }"
                        :class="{
                          disabled: props.row.mande.replaceAll(',', '') <= 0,
                        }"
                        class="loan-own-chip loan-own-chip--ghost"
                      >
                        کاردکس
                      </router-link>
                    </div>
                  </template>
                  <template slot="empty-results">
                    <p class="text-right mb-0">اطلاعاتی یافت نشد</p>
                  </template>
                </vue-bootstrap4-table>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="Logotab"
            role="tabpanel"
            aria-labelledby="Logotab-tab"
          >
            <div class="container loan-tab-body mb-3">
              <div v-if="CardItemTaahodatSahebHesab.length > 0" class="row">
                <div class="col-md-2 col-12">
                  <net-pa-filter-dropdown
                    button-id="loanDependentFilterButton"
                    label="تسهیلات وابسته"
                  >
                    <a
                      class="dropdown-item"
                      href="javascript:;"
                      v-for="item in groupBy"
                      :key="item.wwwtblAzaId"
                      :id="item.wwwtblAzaId"
                      @click="
                        GetSahebHesab(item.wwwtblAzaId, false);
                        $ResetTimer();
                      "
                    >
                      {{ item.nameFamily }}</a
                    >
                    <hr />

                    <a
                      class="dropdown-item"
                      href="Javascript:;"
                      @click="
                        GetSahebHesab(0, true);
                        $ResetTimer();
                      "
                      >همه تسهيلات وابسته
                      <i class="fas fa-check text-success"></i>
                    </a>
                  </net-pa-filter-dropdown>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-12">
                  <div class="alert alert-warning w-100 text-center">
                    در حال حاضر تسهیلات وابسته شما صفر میباشد
                  </div>
                </div>
              </div>
              <div
                v-if="
                  FilterCardItemTaahodatSahebHesab &&
                  FilterCardItemTaahodatSahebHesab.length > 0 &&
                  IsTaahodatSahebHesab == true &&
                  IsShowCard == true
                "
                class="row account-cards-grid"
              >
                <div
                  class="col-12 col-md-6 col-xl-4 account-card-col"
                  v-for="(item, index) in FilterCardItemTaahodatSahebHesab"
                  :key="item.id || index"
                >
                  <div
                    class="card Netpa-Shadow border-0 mb-3 costom-card-sahebanhesab"
                    dir="rtl"
                  >
                    <div class="row border-bottom">
                      <div class="col-12">
                        <div class="account-card-toolbar">
                          <div class="account-card-toolbar__start">
                            <router-link
                              title="گردش تسهیلات"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                  wwwtblAzaId: item.wwwtblAzaId,
                                },
                              }"
                            >
                              <span
                                class="fas fa-list text-warning"
                                style="font-size: 16px"
                              ></span>
                            </router-link>
                            <a
                              data-toggle="modal"
                              data-target="#Modal-Mobile"
                              @click="OpenDetailSahebanHesab(index)"
                              title="جزئیات تسهیلات"
                            >
                              <span
                                class="fas fa-info-circle text-primary Pointer"
                                style="font-size: 15px"
                              ></span>
                            </a>
                            <a
                              href="javascript:;"
                              class="badge"
                              title="افزودن به لیست پرداخت"
                              @click="AddToCart(item, false)"
                              :class="
                                item.mande.replaceAll(',', '') +
                                  Number(item.wwwJarime) -
                                  item.sumMabTaeedNaShode.replaceAll(',', '') >
                                0
                                  ? ''
                                  : 'd-none'
                              "
                            >
                              <i
                                class="fas fa-cart-plus text-succes"
                                style="font-size: 15px"
                              ></i>
                            </a>
                          </div>
                          <div class="account-card-toolbar__end">
                            <span class="loan-card-owner-name">
                              <span
                                class="fas fa-user text-success loan-card-owner-name__icon"
                              ></span>
                              {{ item.nameFamily }}
                            </span>
                            <button
                              v-if="item.shenaseVariz"
                              type="button"
                              class="account-card-share"
                              title="اشتراک‌گذاری لینک پرداخت"
                              @click="sharePaymentLink(item)"
                            >
                              <i class="fas fa-share-alt"></i>
                            </button>
                          </div>
                        </div>
                        <hr />
                      </div>
                      <div class="col-12 text-right account-card-body-main">
                        <div class="account-card-fields">
                          <div class="account-card-field-row">
                            <label
                              class="account-card-field-row__label font-weight-bold"
                              >نوع تسهیلات :</label
                            >
                            <span
                              class="account-card-field-row__value font-weight-bold text-dark"
                              >{{ item.desNoe }}</span
                            >
                          </div>
                          <div class="account-card-field-row">
                            <label
                              class="account-card-field-row__label font-weight-bold"
                              >شماره تسهیلات :</label
                            >
                            <span
                              dir="rtl"
                              class="account-card-field-row__value font-weight-bold text-dark"
                              >{{ item.vCode }}</span
                            >
                          </div>
                          <div class="account-card-field-row">
                            <label
                              class="account-card-field-row__label font-weight-bold"
                              >تاریخ شروع اقساط :</label
                            >
                            <span
                              class="account-card-field-row__value font-weight-bold text-dark"
                              >{{ item.tarixShoroAghsat }}</span
                            >
                          </div>
                          <div class="account-card-field-row">
                            <label
                              class="account-card-field-row__label font-weight-bold"
                              >مبلغ تسهیلات :</label
                            >
                            <span
                              class="account-card-field-row__value font-weight-bold text-dark"
                              >{{ $Comma3ragham(item.mablaghVam) }}</span
                            >
                          </div>
                          <div class="account-card-field-row">
                            <label
                              class="account-card-field-row__label font-weight-bold"
                              >شناسه واریز :</label
                            >
                            <span
                              class="account-card-field-row__value font-weight-bold text-dark"
                              >{{ item.shenaseVariz }}</span
                            >
                          </div>
                          <div class="account-card-field-row">
                            <label
                              class="account-card-field-row__label font-weight-bold text-danger"
                              >مجموع معوق :</label
                            >
                            <span
                              class="account-card-field-row__value font-weight-bold text-danger"
                            >
                              {{
                                $Comma3ragham(item.sumMabMoavaghe) == "null"
                                  ? "-"
                                  : $Comma3ragham(item.sumMabMoavaghe)
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="account-card-balance-footer">
                      <div class="account-card-balance-block">
                        <div class="account-card-balance-row">
                          <label
                            class="account-card-balance-row__label font-weight-bold"
                            >مبلغ قسط :</label
                          >
                          <span
                            class="account-card-balance-row__value font-weight-bold text-dark"
                          >
                            {{ $Comma3ragham(item.mablaghGhestVam) }}
                          </span>
                        </div>
                        <div class="account-card-balance-row">
                          <label
                            class="account-card-balance-row__label font-weight-bold"
                            >مانده تسهیلات :</label
                          >
                          <span
                            class="account-card-balance-row__value font-weight-bold text-dark"
                          >
                            {{
                              $Comma3ragham(
                                Number(item.mande.replaceAll(",", "")) -
                                  Number(
                                    item.sumMabTaeedNaShode.replaceAll(",", ""),
                                  ),
                              )
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2 account-card-actions">
                      <div
                        class="col-md-4 col-12"
                        v-if="
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 11)[0].isMenu
                        "
                      >
                        <a
                          @click="Deposit(item, tasveye(item.id))"
                          :class="
                            item.mande.replaceAll(',', '') +
                              Number(item.wwwJarime) -
                              item.sumMabTaeedNaShode.replaceAll(',', '') >
                            0
                              ? ''
                              : 'disabled'
                          "
                          class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                          style="font-size: 0.79rem !important"
                        >
                          پرداخت
                        </a>
                      </div>
                      <div class="col-md-4 col-12">
                        <router-link
                          :to="{
                            name: 'LoanCardex',
                            params: {
                              TaahodatId: item.id,
                              wwwtblAzaId: item.wwwtblAzaId,
                            },
                          }"
                          :class="
                            item.mande.replaceAll(',', '') > 0 ? '' : 'disabled'
                          "
                          class="btn loan-cardex-btn custom-class NetPa-btn mb-1 w-100 no-wrap"
                          style="font-size: 0.79rem !important"
                        >
                          کاردکس
                        </router-link>
                      </div>
                      <div class="col-md-4 col-12">
                        <router-link
                          title="گردش تسهیلات"
                          :to="{
                            name: 'Turnover',
                            params: {
                              TaahodatId: item.id,
                              wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                              wwwtblAzaId: item.wwwtblAzaId,
                            },
                          }"
                          class="btn custom-class NetPa-btn mb-1 w-100 no-wrap loan-own-chip loan-own-chip--turn"
                          style="font-size: 0.79rem !important"
                        >
                          گردش تسهیلات
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <vue-bootstrap4-table
                    v-if="IsShowCard == false"
                    :rows="rows2"
                    :columns="columns2"
                    :config="config"
                    :classes="classes"
                  >
                    <template slot="sort-asc-icon">
                      <i class="fa fa-sort-up"></i>
                    </template>
                    <template slot="sort-desc-icon">
                      <i class="fa fa-sort-down"></i>
                    </template>
                    <template slot="no-sort-icon">
                      <i class="fa fa-sort"></i>
                    </template>
                    <template slot="action-slot" slot-scope="props">
                      <div class="row">
                        <div class="col-xl-6 col-12">
                          <a
                            v-if="
                              $session
                                .get('AccessMenu')
                                .filter((x) => x.id == 11)[0].isMenu
                            "
                            @click="Deposit(props.row, tasveye(props.row.id))"
                            :class="
                              props.row.mande.replaceAll(',', '') +
                                Number(props.row.wwwJarime) -
                                props.row.sumMabTaeedNaShode.replaceAll(
                                  ',',
                                  '',
                                ) >
                              0
                                ? ''
                                : 'disabled'
                            "
                            class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                            >پرداخت</a
                          >
                        </div>
                        <div class="col-xl-6 col-12">
                          <a
                            href="javascript:;"
                            title="افزودن به لیست پرداخت"
                            @click="AddToCart(props.row, false)"
                            :class="
                              props.row.mande.replaceAll(',', '') +
                                Number(props.row.wwwJarime) -
                                props.row.sumMabTaeedNaShode.replaceAll(
                                  ',',
                                  '',
                                ) >
                              0
                                ? ''
                                : 'd-none'
                            "
                            class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                          >
                            <i
                              class="fas fa-cart-plus text-succes"
                              style="font-size: 15px"
                            ></i
                            >افزودن</a
                          >
                        </div>

                        <div class="col-xl-6 col-12">
                          <router-link
                            title="گردش تسهیلات"
                            :to="{
                              name: 'Turnover',
                              params: {
                                TaahodatId: props.row.id,
                                wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                wwwtblAzaId: props.row.wwwtblAzaId,
                              },
                            }"
                            class="btn custom-class NetPa-btn mb-1 w-100 no-wrap loan-own-chip loan-own-chip--turn"
                          >
                            گردش تسهیلات
                          </router-link>
                        </div>
                        <div class="col-xl-6 col-12">
                          <router-link
                            :to="{
                              name: 'LoanCardex',
                              params: { TaahodatId: props.row.id },
                            }"
                            :class="
                              props.row.mande.replaceAll(',', '') -
                                props.row.sumMabTaeedNaShode.replaceAll(
                                  ',',
                                  '',
                                ) >
                              0
                                ? ''
                                : 'disabled'
                            "
                            class="btn loan-cardex-btn custom-class NetPa-btn mb-1 w-100 no-wrap"
                          >
                            کاردکس</router-link
                          >
                        </div>
                      </div>
                    </template>
                    <template slot="empty-results">
                      <p class="text-right">اطلاعاتی یافت نشد</p>
                    </template>
                  </vue-bootstrap4-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>

    <div v-if="CartValue.length > 0 || IsCart" class="row loan-cart-row">
      <div class="col-md-8 col-12">
        <div
          v-for="list in CartValue"
          :key="list.Id"
          class="row border-right border-success Netpa-Shadow-2 bg-white p-1 mt-2 px-4"
          style="border-right: solid 4px !important"
        >
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2">
            <span class="text-secondary"
              >{{
                $GetIsAnbohSaz() == "false" ? "نام تسهیلات" : "نام قرارداد"
              }}:
            </span>
            <br />
            <small class="no-wrap">{{ list.desNoe }}</small>
          </div>
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
            <span class="text-secondary">{{
              $GetIsAnbohSaz() == "false" ? "شماره تسهیلات" : "شماره قرارداد"
            }}</span
            ><br />
            <small class="no-wrap" dir="rtl">{{ list.vCode }}</small>
          </div>
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
            <span class="text-secondary">مبلغ قسط</span><br />
            <input
              v-if="list.sumMabMoavaghe == 0"
              class="form-control 3ragham text-center mt-2"
              style="font-size: 14px !important"
              v-model="list.mablaghGhestVam"
            />
            <input
              v-else
              class="form-control 3ragham text-center mt-2"
              style="font-size: 14px !important"
              v-model="list.sumMabMoavaghe"
            />
          </div>
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
            <span class="text-secondary">مبلغ جریمه</span><br />
            <span class="text-danger" dir="rtl">{{
              list.wwwJarime == null ? 0 : $Comma3ragham(list.wwwJarime)
            }}</span>
          </div>
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
            <span class="text-secondary">جمع مبلغ قسط</span><br />

            <span
              v-if="$store.state.renderComponent"
              class="text-success"
              dir="rtl"
              >{{
                $Comma3ragham(
                  SumSekhavat[list.id] != null
                    ? SumSekhavat[list.id]
                    : Number(list.mablaghGhestVam.replaceAll(",", "")) +
                        Number(list.wwwJarime == null ? 0 : list.wwwJarime),
                )
              }}</span
            >
          </div>
          <div class="col-12 mt-md-0 mt-2 col-md-2" dir="rtl">
            <button
              type="button"
              class="btn btn-outline-dark mt-3"
              style="font-size: 14px !important"
              data-toggle="modal"
              data-target="#Modal-Orange"
              dir="ltr"
              @click="GetTaahodatRizSetId(list)"
            >
              <span class="fa fa-list" tabindex="-1"></span>
            </button>
            <button
              type="button"
              class="btn btn-outline-danger mt-3 mr-1"
              style="font-size: 14px !important"
              @click="
                DeleteToCart(list.id);
                $ResetTimer();
              "
              dir="ltr"
            >
              <span class="fa fa-trash-alt" tabindex="-1"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 text-center">
        <payment
          v-if="IsCart"
          @GatewayCode="Get_GatewayCode"
          @FixVarizGhest="FixVarizGhest"
        >
          <template v-slot:ContentButtonPayment>
            <button
              v-if="$store.state.renderComponent"
              class="btn btn-lg btn-success w-50"
              tabindex="2"
              @click="GetMablaghOK()"
            >
              {{ total }}
            </button>
          </template>
        </payment>
      </div>
    </div>

    <modal-custom v-if="$store.state.renderComponent">
      <template v-slot:HeaderModalInfo>
        <span>
          <i
            class="fas fa-info-circle text-dark mx-2"
            style="font-size: 16 !important"
          ></i>
          <span
            style="font-size: 16 !important"
            class="text-light font-weight-bold"
            >جزئیات تسهیلات</span
          >
        </span>
      </template>
      <template v-slot:ContentModalMobile>
        <div class="netpa-account-detail-modal" dir="rtl">
          <div
            v-if="detailInModal != null"
            class="netpa-account-detail-modal__panel"
          >
            <div class="netpa-account-detail-modal__header">
              <h6 class="netpa-account-detail-modal__title">
                <i class="fas fa-info-circle ml-2"></i>
                جزئیات تسهیلات
              </h6>
              <hr class="netpa-account-detail-modal__header-divider" />
              <p class="netpa-account-detail-modal__account-type">
                <i class="fas fa-money-check ml-2"></i>
                {{ CardItem[detailInModal].desNoe }}
              </p>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-file-invoice ml-2"></i>
              اطلاعات اصلی
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >شماره تسهیلات:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItem[detailInModal].vCode
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مبلغ اصل وام:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].mablaghVam)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مانده:</span>
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].mande)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >کارمزد (۱):</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].mablaghKarmozd1)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تاریخ شروع اقساط:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItem[detailInModal].tarixShoroAghsat
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مبلغ کل وام:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(loanModalTotal(CardItem[detailInModal]))
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >موارد مصرف:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItem[detailInModal].comment || "—"
                }}</span>
              </div>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-calendar-alt ml-2"></i>
              اقساط
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مبلغ قسط:</span>
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].mablaghGhestVam)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مبلغ اولین قسط:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].mablaghAvalinGhest)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >سررسید قسط پرداخت نشده:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  String(
                    CardItem[detailInModal].minTarGhestBedehkar || "",
                  ).replaceAll(/,/g, "")
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مبلغ آخرین قسط:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].mabLastGhest)
                }}</span>
              </div>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-list-ol ml-2"></i>
              وضعیت اقساط
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تعداد اقساط:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItem[detailInModal].tedadGhestVam
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تعداد اقساط پرداخت نشده:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItem[detailInModal].tedadAghsatPardaxtNaShode
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >کارمزد (۲):</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].mablaghKarmozd2)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تعداد اقساط پرداخت شده:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItem[detailInModal].tedadAghsatPardaxtShode
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مجموع اقساط پرداخت نشده:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].sumMabBedehi)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تعداد اقساط معوقه:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItem[detailInModal].tedadMoavaghe
                }}</span>
              </div>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-chart-line ml-2"></i>
              خلاصه پرداخت
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مجموع اقساط پرداخت شده:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].sumMabPar)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مبلغ معوقه:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].sumMabMoavaghe) ==
                  "null"
                    ? "—"
                    : $Comma3ragham(CardItem[detailInModal].sumMabMoavaghe)
                }}</span>
              </div>
            </div>

            <div
              v-if="
                ($session.get('CustCode') == 868 ||
                  $session.get('CustCode') == 954 ||
                  $session.get('CustCode') == 8002) &&
                tasveye(CardItem[detailInModal].id).mabTasveye > 0
              "
              class="netpa-account-detail-modal__score text-right"
            >
              <p class="netpa-account-detail-modal__score-note mb-2">
                بدهی به شرط تسویه زودتر از موعد:
                <strong>{{
                  $Comma3ragham(tasveye(CardItem[detailInModal].id).mabTasveye)
                }}</strong>
              </p>
              <button
                type="button"
                @click="
                  Deposit(
                    CardItem[detailInModal],
                    tasveye(CardItem[detailInModal].id),
                  )
                "
                data-dismiss="modal"
                class="btn loan-cardex-btn btn-sm"
              >
                تسویه تسهیلات
              </button>
            </div>
          </div>

          <div
            v-if="detailInModalSahebHesab != null"
            class="netpa-account-detail-modal__panel"
          >
            <div class="netpa-account-detail-modal__header">
              <h6 class="netpa-account-detail-modal__title">
                <i class="fas fa-info-circle ml-2"></i>
                جزئیات تسهیلات
              </h6>
              <hr class="netpa-account-detail-modal__header-divider" />
              <p class="netpa-account-detail-modal__account-type">
                <i class="fas fa-money-check ml-2"></i>
                {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].desNoe }}
              </p>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-file-invoice ml-2"></i>
              اطلاعات اصلی
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >شماره تسهیلات:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab].vCode
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مبلغ وام:</span>
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mablaghVam,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مانده:</span>
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab].mande,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تاریخ شروع اقساط:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                    .tarixShoroAghsat
                }}</span>
              </div>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-calendar-alt ml-2"></i>
              اقساط
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مبلغ قسط:</span>
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mablaghGhestVam,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مبلغ اولین قسط:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mablaghAvalinGhest,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مبلغ آخرین قسط:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mabLastGhest,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >سررسید اولین بدهی:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  String(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .minTarGhestBedehkar || "",
                  ).replaceAll(/,/g, "")
                }}</span>
              </div>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-list-ol ml-2"></i>
              وضعیت اقساط
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تعداد اقساط:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                    .tedadGhestVam
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >کارمزد (۱):</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mablaghKarmozd1,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >کارمزد (۲):</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mablaghKarmozd2,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تعداد اقساط پرداخت شده:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                    .tedadAghsatPardaxtShode
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تعداد اقساط پرداخت نشده:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                    .tedadAghsatPardaxtNaShode
                }}</span>
              </div>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-chart-line ml-2"></i>
              خلاصه پرداخت
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مجموع اقساط پرداخت شده:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .sumMabPar,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مجموع اقساط پرداخت نشده:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .sumMabBedehi,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تعداد اقساط معوقه:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                    .tedadMoavaghe
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مبلغ معوقه:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .sumMabMoavaghe,
                  ) == "null"
                    ? "—"
                    : $Comma3ragham(
                        CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                          .sumMabMoavaghe,
                      )
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:ContentModalOrange>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="bg-light">
              <tr>
                <th scope="col">#</th>
                <th scope="col">تاریخ قسط</th>
                <th scope="col">مبلغ قسط</th>
                <th scope="col">مبلغ جریمه</th>
                <th scope="col">تاریخ سند</th>
                <th scope="col">شماره سند</th>
                <th scope="col">عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(itemRiz, key) in ListTaahodatRiz"
                :key="itemRiz.id"
                :class="itemRiz.select == true ? 'bg-success-custom' : ''"
              >
                <th scope="row">{{ key + 1 }}</th>
                <td>{{ itemRiz.tarixGhest }}</td>
                <td>{{ $Comma3ragham(itemRiz.mablaghGhest) }}</td>
                <td>{{ $Comma3ragham(itemRiz.mabJarime) }}</td>
                <td>
                  {{
                    itemRiz.tarixSanad == null
                      ? "سند ثبت نشده"
                      : itemRiz.tarixSanad
                  }}
                </td>
                <td>
                  {{
                    itemRiz.shomareSanad == null
                      ? "سند ثبت نشده"
                      : itemRiz.shomareSanad
                  }}
                </td>
                <td>
                  <button
                    type="button"
                    class="badge font-weight-normal px-2 py-1 mr-1 w-100"
                    :class="
                      itemRiz.select == true
                        ? ' btn-outline-orange'
                        : ' btn-outline-success bg-light'
                    "
                    dir="ltr"
                    @click="SelectRiz(itemRiz)"
                  >
                    <span class="mr-2">{{
                      itemRiz.select == true ? "حذف" : "انتخــاب"
                    }}</span>
                    <span
                      :class="
                        itemRiz.select == true ? 'fa fa-times' : 'fa fa-check'
                      "
                    ></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <button
            v-if="ListTaahodatRiz != null && ListTaahodatRiz != []"
            type="button"
            class="btn btn-success mr-1"
            dir="ltr"
            :disabled="sumMabRiz <= 0 ? true : false"
            data-dismiss="modal"
            @click="SetMablagh(ListTaahodatRiz[0].wwwtblTaahodatId)"
          >
            <span v-if="sumMabRiz[ListTaahodatRiz[0].wwwtblTaahodatId] > 0">
              تایید مبلغ
              <span class="mr-2">{{
                $Comma3ragham(sumMabRiz[ListTaahodatRiz[0].wwwtblTaahodatId])
              }}</span>
              {{ $GetVahedPool() }}</span
            >
            <span v-else>لطفا یک یا چند قسط را انتخاب نمایید</span>
          </button>
        </div>
      </template>
      <template v-slot:ContentModalBanafash>
        <loan-cardex
          :FilterMoavaghe="true"
          :TaahodatId="TaahodatIdForCardex"
          :wwwtblAzaId="wwwtblAzaIdForCardex"
          :modalSubtitle="moavagheModalSubtitle"
        ></loan-cardex>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaViewToggle from "../Tools/NetPa/NetPaViewToggle.vue";
import NetPaFilterDropdown from "../Tools/NetPa/NetPaFilterDropdown.vue";
import Payment from "./Payment.vue";
import ModalCustom from "../Tools/ModalCustom.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";
import LoanCardex from "./LoanCardex.vue";
import html2pdf from "html2pdf.js";
export default {
  data() {
    return {
      TableSetting: null,
      wwwtblAzaIdForCardex: null,
      TaahodatIdForCardex: null,
      moavagheModalSubtitle: "",
      loadingRender: false,
      CardItem: null,
      CardItemTaahodatSahebHesab: [],
      FilterCardItemTaahodatSahebHesab: null,
      groupBy: null,
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_CheckUpMande: {
        ArryfildValue: {},
        Method: "Post",
        Action: "CheckUpMande",
        Token: this.$session.get("TokenNetPa"),
      },
      selectedBedehi: true,
      selectedAllBedehi: false,
      CartValue: [],
      IsCart: false,
      // SumMablagh: 0,
      GatewayCode: null,
      detailInModal: null,
      FixVariz: false,
      ListTaahodatRiz: null,
      CountSelectedTaahodatRiz: 0,
      CountSelectedTaahodatRizMovaghat: 0,
      sumMabRiz: {},
      SumSekhavat: {},
      totla: 0,
      IsTaahodatSahebHesab: false,
      detailInModalSahebHesab: null,
      IsShowCard: true,
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نوع",
          name: "desNoe",
        },
        {
          label: "شماره ",
          name: "vCode",
        },
        {
          label: " شروع اقساط ",
          name: "tarixShoroAghsat",
        },
        {
          label: "مبلغ تسهیلات",
          name: "mablaghVam",
        },
        {
          label: "شناسه واریز",
          name: "shenaseVariz",
        },
        {
          label: "مجموع معوق",
          name: "sumMabMoavaghe",
        },
        {
          label: "مبلغ قسط",
          name: "mablaghGhestVam",
        },
        {
          label: "مانده تسهیلات",
          name: "NewMande",
        },
        {
          label: "عملیات ها",
          name: "id",
          slot_name: "action-slot",
          sort: false,
        },
      ],
      rows2: [],
      columns2: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نوع",
          name: "desNoe",
        },
        {
          label: "شماره ",
          name: "vCode",
        },
        {
          label: "مشخصات",
          name: "nameFamily",
        },
        {
          label: " شروع اقساط ",
          name: "tarixShoroAghsat",
        },
        {
          label: "مبلغ تسهیلات",
          name: "mablaghVam",
        },
        {
          label: "شناسه واریز",
          name: "shenaseVariz",
        },
        {
          label: "مجموع معوق",
          name: "sumMabMoavaghe",
        },
        {
          label: "مبلغ قسط",
          name: "mablaghGhestVam",
        },
        {
          label: "مانده تسهیلات",
          name: "NewMande",
        },
        {
          label: "عملیات ها",
          name: "id",
          slot_name: "action-slot",
          sort: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped  ",
      },

      DataAxiosRowCart: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesabCart: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },

      LoanList: [],
      ChildsLoanList: [],
      mabTasveye: {},
    };
  },
  components: {
    NetPaCard,
    NetPaTab,
    Panel,
    NetPaViewToggle,
    NetPaFilterDropdown,
    Payment,
    ModalCustom,
    VueBootstrap4Table,
    loading,
    LoanCardex,
  },
  computed: {
    LoanTabs() {
      const isLoan = this.$GetIsAnbohSaz() == "false";
      const tabs = [
        {
          id: "Detailtab",
          title: isLoan ? "تسهیلات خودم" : "پروژه های من",
        },
      ];
      if (isLoan) tabs.push({ id: "Logotab", title: "تسهیلات وابسته" });
      return tabs;
    },
    GetMablagh() {
      var mab = 0;
      for (let index = 0; index < this.CartValue.length; index++) {
        if (this.SumSekhavat[this.CartValue[index].id]) {
          mab = mab + Number(this.SumSekhavat[this.CartValue[index].id]);
        } else {
          mab +=
            Number(this.CartValue[index].mablaghGhestVam) +
            Number(
              this.CartValue[index].wwwJarime == null
                ? 0
                : this.CartValue[index].wwwJarime,
            );
        }
      }
      mab = mab / 10;
      return " پرداخت " + this.$Comma3ragham(mab) + " تومان ";
    },
  },
  mounted() {
    this.GetItemCard(false);
    const filterBtn = document.getElementById("loanFilterButton");
    if (filterBtn) {
      filterBtn.click();
    }
    this.GetItemCardTaahodatSahebHesab();
    this.GetTableBank();
  },

  methods: {
    tasveye(val) {
      this.$GetTasveye(
        val,
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      ).then((data) => {
        this.mabTasveye = data;
      });
      return this.mabTasveye;
    },
    ShowCard(status) {
      this.IsShowCard = status;
    },
    GetMablaghs() {
      var mab = 0;
      for (let index = 0; index < this.CartValue.length; index++) {
        if (this.SumSekhavat[this.CartValue[index].id]) {
          mab = mab + Number(this.SumSekhavat[this.CartValue[index].id]);
        } else {
          mab +=
            Number(this.CartValue[index].mablaghGhestVam.replaceAll(",", "")) +
            Number(
              this.CartValue[index].wwwJarime == null
                ? 0
                : this.CartValue[index].wwwJarime,
            );
        }
      }
      mab = mab / 10;

      return " پرداخت " + this.$Comma3ragham(mab) + " تومان ";
    },
    GetSahebHesab(id, IsAll) {
      let info;
      let list = [];
      if (IsAll) {
        this.IsTaahodatSahebHesab = true;
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab;
        for (
          let index = 0;
          index < this.FilterCardItemTaahodatSahebHesab.length;
          index++
        ) {
          info = this.FilterCardItemTaahodatSahebHesab[index];
          info["NewMande"] =
            this.FilterCardItemTaahodatSahebHesab[index].mande -
            this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode;
          info["NewghabelBardasht"] =
            this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht;
          list.push(info);
        }
        this.rows2 = this.$FormatMablaghGrid(list);
      } else {
        this.IsTaahodatSahebHesab = true;
        this.FilterCardItemTaahodatSahebHesab =
          this.CardItemTaahodatSahebHesab.filter((x) => x.wwwtblAzaId == id);
        for (
          let index = 0;
          index < this.FilterCardItemTaahodatSahebHesab.length;
          index++
        ) {
          info = this.FilterCardItemTaahodatSahebHesab[index];
          info["NewMande"] =
            this.FilterCardItemTaahodatSahebHesab[index].mande -
            this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode;
          info["NewghabelBardasht"] =
            this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht;
          list.push(info);
        }
        this.rows2 = this.$FormatMablaghGrid(list);
      }
    },
    GetItemCard(IsAll) {
      let info;
      let list = [];

      const applyData = (data) => {
        this.EditRowsLoan(data);
        if (IsAll) {
          this.CardItem = data;
          this.selectedBedehi = false;
          this.selectedAllBedehi = true;

          for (let index = 0; index < data.length; index++) {
            info = data[index];
            info["NewMande"] =
              data[index].mande - data[index].sumMabTaeedNaShode;
            list.push(info);
          }
          this.rows = this.$FormatMablaghGrid(list);
        } else {
          this.CardItem = data.filter(
            (x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0,
          );

          this.selectedBedehi = true;
          this.selectedAllBedehi = false;
          for (let index = 0; index < data.length; index++) {
            info = data[index];
            info["NewMande"] =
              data[index].mande - data[index].sumMabTaeedNaShode;
            list.push(info);
          }
          this.rows = this.$FormatMablaghGrid(
            list.filter(
              (x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0,
            ),
          );
        }
      };

      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 1);
      this.DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        applyData(data);
      });
    },
    GetItemCardTaahodatSahebHesab() {
      const applyDependentData = (data) => {
        this.EditRowsLoan(data);
        this.CardItemTaahodatSahebHesab = data.filter(
          (x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0,
        );
        var result = this.CardItemTaahodatSahebHesab.reduce((unique, o) => {
          if (
            !unique.some(
              (obj) =>
                obj.wwwtblAzaId === o.wwwtblAzaId && obj.value === o.value,
            )
          ) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.groupBy = result;
      };

      const finishLoading = () => {
        if (this.$session.get("UserFromLoan")) {
          if (this.$session.get("UserFromLoan")[1] == true) {
            if (
              this.$session.get("UserFromLoan")[0] !=
              this.$session.get("UserInfoNetPa").wwwtblAzaId
            ) {
              document.getElementById("Logotab-tab").click();
              document
                .getElementById(this.$session.get("UserFromLoan")[0])
                .click();
              this.$session.remove("UserFromLoan");
            }
          }
        }
        this.loadingRender = false;
      };

      this.loadingRender = true;

      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 1);
      this.DataAxios_SahebHesab.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_SahebHesab)
        .then((data) => {
          applyDependentData(data);
        })
        .catch(() => {})
        .finally(() => {
          finishLoading();
        });
    },
    DeleteToCart(id) {
      var a = this.CartValue.map(function (item) {
        return item.id;
      }).indexOf(id);
      this.CartValue.splice(a, 1);

      if (this.CartValue.length == 0) {
        this.IsCart = false;
      }
      this.total = this.GetMablaghs();
    },
    GetMablaghOK() {
      var mab = 0;
      for (let index = 0; index < this.CartValue.length; index++) {
        if (this.SumSekhavat[this.CartValue[index].id]) {
          mab = mab + Number(this.SumSekhavat[this.CartValue[index].id]);
        } else {
          mab +=
            Number(this.CartValue[index].mablaghGhestVam.replaceAll(",", "")) +
            Number(
              this.CartValue[index].wwwJarime == null
                ? 0
                : this.CartValue[index].wwwJarime,
            );
        }
      }
      const WwwtblVarizGorohiRiz = [];
      for (let index = 0; index < this.CartValue.length; index++) {
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: this.CartValue[index].id,
          Mablagh: Number(
            this.CartValue[index].mablaghGhestVam.replaceAll(",", ""),
          ),
          SharhRiz: " پرداخت قسط تسهیلات " + this.CartValue[index].vCode,
          WwwtblAzaId: this.CartValue[index].wwwtblAzaId,
          BnpCashDBtblTaahodatId: this.CartValue[index].bnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.CartValue[index].bnpCashDBtblAzaId,
          MablaghJarime:
            this.CartValue[index].wwwJarime == null
              ? 0
              : this.CartValue[index].wwwJarime,
          TarixGhest: this.CartValue[index].minTarGhestBedehkar,
        });
      }
      this.SumMablagh = mab;
      this.DataAxios_Variz.ArryfildValue.Mablagh = this.SumMablagh;
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
      this.DataAxios_Variz.ArryfildValue.Sharh = "پرداخت اقساط گروهی";
      this.DataAxios_Variz.ArryfildValue.ZamanInsert =
        this.$store.state.JalaliDate;
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(
        this.$session.get("UserInfoNetPa").custCode,
      );
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
        this.$session.get("UserInfoNetPa").wwwtblAzaId;
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
        WwwtblVarizGorohiRiz;
      this.$PostData(this.DataAxios_Variz).then((result) => {
        this.$Payment(
          this.GatewayCode + "",
          JSON.stringify(this.SumMablagh),
          this.$session.get("UserInfoNetPa").ozvName +
            " " +
            this.$session.get("UserInfoNetPa").ozvFamily,
          this.$session.get("UserInfoNetPa").email,
          this.$session.get("UserInfoNetPa").mobile,
          WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
          "",
          this.CartValue[0].vCode,
          "سبد اقساط",
          JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblAzaId),
          this.$session.get("UserInfoNetPa").custCode,
          JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblShobeId),
          result.idRepoMaster,
          this.$session.get("UserInfoNetPa").codeMeli,
        );
      });
    },
    Deposit(item, mabTasveyeZodtar) {
      const formData = new FormData();
      formData.append("wwwtblTaahodatId", item.id);
      this.DataAxios_CheckUpMande.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_CheckUpMande).then((data) => {});

      this.$router.push({
        name: "Deposit",
        params: {
          TaahodatItem: item,
          IsTashilat: true,
          wwwtblAzaId: item.wwwtblAzaId,
          mabTasveyeZodtar: mabTasveyeZodtar.mabTasveye
            ? mabTasveyeZodtar.mabTasveye
            : 0,
          mabReturnrKarmozd: mabTasveyeZodtar.sumKarmozd
            ? mabTasveyeZodtar.sumKarmozd
            : 0,
        },
      });
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val;
    },
    FixVarizGhest(val) {
      this.FixVariz = val;
    },
    OpenDetail(index) {
      this.detailInModalSahebHesab = null;
      this.detailInModal = index;
    },
    loanModalTotal(item) {
      const num = (val) =>
        Number(
          String(val || 0)
            .replace(/,/g, "")
            .replace(/\./g, ""),
        ) || 0;
      return num(item.mablaghKarmozd1) + num(item.mablaghVam);
    },
    OpenDetailSahebanHesab(index) {
      this.detailInModal = null;
      this.detailInModalSahebHesab = index;
    },
    GetTaahodatRizSetId(taahodat) {
      this.GetTaahodatRiz(taahodat.id);
      this.Alaki = taahodat;
    },
    SelectRiz(itemRiz) {
      if (itemRiz.shomareSanad == null || itemRiz.tarixSanad == null) {
        itemRiz.select = !itemRiz.select;
        let ItemMab = itemRiz.mablaghGhest;
        if (!this.sumMabRiz[itemRiz.wwwtblTaahodatId]) {
          this.sumMabRiz[itemRiz.wwwtblTaahodatId] = 0;
        }
        if (itemRiz.select) {
          this.CountSelectedTaahodatRizMovaghat += 1;
          this.sumMabRiz[itemRiz.wwwtblTaahodatId] =
            this.sumMabRiz[itemRiz.wwwtblTaahodatId] + ItemMab;
        } else {
          if (this.CountSelectedTaahodatRiz > 0) {
            this.CountSelectedTaahodatRizMovaghat -= 1;
          }
          this.sumMabRiz[itemRiz.wwwtblTaahodatId] =
            this.sumMabRiz[itemRiz.wwwtblTaahodatId] - ItemMab;
        }
      } else {
        this.$mySweetDefaultTost(
          "عدم انتخاب",
          "قسط انتخابی شما ثبت سند شده ، لطفا قسط دیگیری را انتخاب کنید",
          "warning",
          3000,
        );
      }
    },
    SetMablagh(taahodid) {
      this.CountSelectedTaahodatRiz = this.CountSelectedTaahodatRizMovaghat;
      if (
        this.$session.get("UserInfoNetPa").cId == "801" ||
        this.$session.get("UserInfoNetPa").cId == "7777"
      ) {
        if (this.CountSelectedTaahodatRiz <= 1) {
          this.SumSekhavat[taahodid] =
            this.sumMabRiz[taahodid] + this.TahoodSelected.wwwJarime + "";
        } else {
          this.SumSekhavat[taahodid] = this.sumMabRiz[taahodid] + "";
        }
      } else {
        this.Mablagh =
          this.sumMabRiz[taahodid] + this.TahoodSelected.wwwJarime + "";
      }
      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });
      this.total = this.GetMablaghs();
    },

    GetTaahodat(IsAccount) {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      if (IsAccount == true) formData.append("wwwtblSarfaslTypeId", 2);
      else formData.append("wwwtblSarfaslTypeId", 1);

      this.DataAxiosRowCart.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRowCart).then((data) => {
        if (IsAccount) {
          this.AccountList = data.filter((x) => x.mande > 0);
          this.EditRowsAccount(this.AccountList);
        } else {
          this.LoanList = data.filter((x) => x.mande > 0);
          this.EditRowsLoan(this.LoanList);
          this.SumGhabelParLoan(this.LoanList);
        }
      });
    },
    GetTaahodatSahebHesab(IsAccount) {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      if (IsAccount == true) formData.append("wwwtblSarfaslTypeId", 2);
      else formData.append("wwwtblSarfaslTypeId", 1);

      this.DataAxios_SahebHesabCart.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_SahebHesabCart)
        .then((data) => {
          if (IsAccount) {
            this.ChildsAccountList = data.filter((x) => x.mande > 0);
            this.EditRowsAccount(this.ChildsAccountList);
          } else {
            this.ChildsLoanList = data.filter(
              (x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0,
            );
            this.EditRowsLoan(this.ChildsLoanList);
            this.SumGhabelParChildLoan(this.ChildsLoanList);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingRender = false;
        });
    },
    AddToCart(row, IsAccount) {
      if (IsAccount == true) {
        if (row.MabVarizi > 0) {
          row.SumGhabelPar = Number(row.MabVarizi);
          this.$Netpa_AddToCart(row, "Account", "حساب ها");
        } else {
          this.$mySweetDefaultTost(
            "مبلغ واریزی غیر مجاز",
            "مبلغ واریزی خالی می باشد لطفا مبلغ واریزی را تکمیل و سپس دوباره تلاش کنید",
            "warning",
            3000,
          );
        }
      }
      if (IsAccount == false) {
        // row.SumGhabelPar=Number(row.SumGhabelPar)
        // this.SumJarimeAndMablaghGhestVam(row);
        this.$Netpa_AddToCart(row, "Loan", "تسهیلات");
      }
    },
    EditRowsLoan(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        // if (listRow[index].sumMabMoavaghe -listRow[index].sumMabTaeedNaShode >0) {
        //      listRow[index].SumGhabelPar=(Number(listRow[index].sumMabMoavaghe)-Number(listRow[index].sumMabTaeedNaShode))+Number(listRow[index].wwwJarime==null?0:listRow[index].wwwJarime);

        // }
        // else if((listRow[index].mabAvalinForPar +listRow[index].sumMabMoavaghe) -listRow[index].sumMabTaeedNaShode >0){
        //       listRow[index].SumGhabelPar=((listRow[index].mabAvalinForPar +listRow[index].sumMabMoavaghe)-listRow[index].sumMabTaeedNaShode)+Number(listRow[index].wwwJarime==null?0:listRow[index].wwwJarime);
        // }
        // else{
        //      listRow[index].SumGhabelPar=Number(listRow[index].mablaghGhestVam)+Number(listRow[index].wwwJarime==null?0:listRow[index].wwwJarime);

        // }
        listRow[index].SumGhabelPar = listRow[index].sumGhabelPar;
      }
    },
    SumJarimeAndMablaghGhestVam(row) {
      row.mablaghGhestVam =
        Number(row.mablaghGhestVam) +
        Number(row.wwwJarime == null ? 0 : row.wwwJarime);
    },
    GetTaahodatRiz(row, IsChild) {
      this.TaahodatIdForGetRiz = row.id;

      this.IsChild = IsChild;

      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });
    },
    SumMablagh(val) {
      if (this.IsChild == true) {
        for (let index = 0; index < this.ChildsLoanList.length; index++) {
          if (this.ChildsLoanList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsLoanList[index].SumGhabelPar =
              val +
              Number(
                this.ChildsLoanList[index].wwwJarime == null
                  ? 0
                  : this.ChildsLoanList[index].wwwJarime,
              );
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          }
        }
      } else {
        for (let index = 0; index < this.LoanList.length; index++) {
          if (this.LoanList[index].id == this.TaahodatIdForGetRiz) {
            this.LoanList[index].SumGhabelPar =
              Number(val) +
              Number(
                this.LoanList[index].wwwJarime == null
                  ? 0
                  : this.LoanList[index].wwwJarime,
              );

            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          }
        }
      }
    },
    AllAddToCart(Arr) {
      for (let index = 0; index < Arr.length; index++) {
        this.$Netpa_AddToCart(Arr[index], "Loan", "تسهیلات");
      }
    },
    SumGhabelParLoan(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        this.SumAllGhabelParLoan += listRow[index].SumGhabelPar;
      }
    },
    SumGhabelParChildLoan(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        this.SumAllGhabelParChildLoan += listRow[index].SumGhabelPar;
      }
    },
    DownloadFishVariz(row) {
      var html = `
                <div class="container mt-4 " style="border: 2px dashed #115eab">
                  <div class="row py-2 mt-3" style="border-bottom: 2px dashed #bfd9f2">
                    <div class="col-6 text-center">
                      <h5 class="text-dark">اطلاعات حساب</h5>
                    </div>
                    <div class="col-6 text-center">
                      <h5 class="text-dark">اطلاعات قرداد</h5>
                    </div>
                  </div>
                  <div class="row mt-4 mb-1">
                    <div class="col-6 text-center px-4"  style="border-left: 2px dashed #bfd9f2">
                      <h6 class=""><span class="text-dark">اطلاعات بانک:</span>&nbsp;&nbsp;<span>  ${
                        this.TableSetting.bankName
                      } </span></h6>
                      <h6 class=""><span class="text-dark">شماره حساب:</span>&nbsp;&nbsp;<span>  ${
                        this.TableSetting.hesabNo
                      }  </span></h6>
                      <h6 class=""><span class="text-dark">شماره شبا:</span>&nbsp;&nbsp;<span>  ${
                        this.TableSetting.shebaNo
                      }  </span></h6>
                      <h6 class=""><span class="text-dark" dir="ltr">شماره کارت:</span>&nbsp;&nbsp;<span>  ${this.TableSetting.cardNo
                        .match(/.{1,4}/g)
                        .join("-")}  </span></h6>
                      <h6 class=""><span class="text-dark">اطلاعات حساب:</span>&nbsp;&nbsp;<span>  ${
                        this.TableSetting.bankDetail
                      } </span></h6>
                    </div>
                    <div class="col-6 text-center px-4">
                      <h6 class=""><span class="text-dark">نام قرارداد:</span>&nbsp;&nbsp;<span>  ${
                        row.desNoe
                      } </span></h6>
                      <h6 class=""><span class="text-dark">شماره قرارداد:</span>&nbsp;&nbsp;<span dir="ltr">  ${
                        row.vCode
                      }  </span></h6>
                      <h6 class=""><span class="text-dark">شناسه واریز:</span>&nbsp;&nbsp;<span> ${
                        row.shenaseVariz
                      }  </span></h6>
                      <h6 class=""><span class="text-dark">مبلغ :</span>&nbsp;&nbsp;<span>  ${this.$Comma3ragham(
                        row.SumGhabelPar,
                      )}  ریال</span></h6>
                    </div>
                  </div>
                </div>
      `;
      var htmlObject = document.createElement("div");
      htmlObject.innerHTML = html;
      html2pdf(htmlObject, {
        jsPDF: { format: "a5", orientation: "landscape" },
      });
    },
    // GetTableSetting(){
    //   var DataAxios_Get = {
    //     ArryfildValue: '',
    //     Method: 'Get',
    //     Action: 'Setting',
    //     Token: this.$session.get('TokenNetPa'),
    //   }
    //   this.$GetData_Body(DataAxios_Get).then((res)=>{
    //     this.TableSetting=res

    //   })
    // }
    paymentLinkUrl(item) {
      const shenase = (item.shenaseVariz || "").toString().trim();
      if (!shenase) return "";
      return `${window.location.origin}/v?sh=${encodeURIComponent(shenase)}`;
    },
    sharePaymentLink(item) {
      const url = this.paymentLinkUrl(item);
      if (!url) {
        this.$mySweetDefaultTost(
          "خطا",
          "شناسه واریز برای این تسهیلات موجود نیست.",
          "error",
          2500,
        );
        return;
      }
      const payload = {
        title: "لینک پرداخت",
        text: `لینک پرداخت تسهیلات ${item.vCode || ""}`,
        url,
      };
      if (navigator.share) {
        navigator.share(payload).catch((err) => {
          if (err && err.name === "AbortError") return;
          this.copyPaymentLink(url);
        });
        return;
      }
      this.copyPaymentLink(url);
    },
    copyPaymentLink(url) {
      const done = () => {
        this.$mySweetDefaultTost(
          "کپی شد",
          "لینک پرداخت در حافظه کپی شد.",
          "success",
          2500,
        );
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(url)
          .then(done)
          .catch(() => this.fallbackCopyPaymentLink(url, done));
        return;
      }
      this.fallbackCopyPaymentLink(url, done);
    },
    fallbackCopyPaymentLink(url, done) {
      const input = document.createElement("textarea");
      input.value = url;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        done();
      } catch (e) {
        this.$mySweetDefaultTost(
          "خطا",
          "امکان اشتراک‌گذاری لینک وجود ندارد.",
          "error",
          2500,
        );
      }
      document.body.removeChild(input);
    },
    GetTableBank() {
      var DataAxios_Get = {
        ArryfildValue: "",
        Method: "Get",
        Action: "Bank/GetBankList",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$GetData_Body(DataAxios_Get).then((res) => {
        res.forEach((bank) => {
          if (
            bank.shebaNo != null &&
            bank.hesabNo != null &&
            bank.bankDetail != null
          ) {
            this.TableSetting = bank;
            return;
          }
        });
      });
    },
  },
  updated() {
    this.GetMablaghs();
  },
};
</script>
<style scoped>
td,
th {
  white-space: normal !important;
}

.fl {
  float: left !important;
}

.border-line {
  border-right: 1px solid #bdbdbd;
  text-align: center;
}

.costom-card {
  padding: 18px 22px;
  border-radius: 15px;
  margin-top: 16px;
  margin-bottom: 16px;
  height: 100%;
  box-sizing: border-box;
}

.costom-card-sahebanhesab {
  padding: 18px 22px;
  border-radius: 15px;
  margin-top: 16px;
  margin-bottom: 16px;
  height: 100%;
  box-sizing: border-box;
}

@media (min-width: 1200px) {
  .costom-card,
  .costom-card-sahebanhesab {
    margin-top: 24px;
    margin-bottom: 24px;
    padding: 20px 28px;
  }
}

@media all and (max-width: 980px) {
  .custom-class {
    width: 100%;
    display: block;
  }
}

.bg-dark-Custom {
  background: #2a3f54 !important;
  /* border:1px solid #2A3F54 !important; */
}

.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}

.btn-outline-orange {
  background: #fff;
}

.bg-success-custom {
  background: #d1bd9e !important;
}

.btn-outline-success {
  background: #ffffff !important;
}

.btn-outline-success:hover {
  background: #5ea31e !important;
  color: #fff;
}
</style>
<style>
#loan .loan-card-owner-name {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.4;
}

#loan .loan-card-owner-name__icon {
  font-size: 1rem;
}

#loan .loan-tab-body {
  margin-top: 0;
  padding-top: 0;
}

#loan .tab-content.p-3 {
  padding-top: 0.5rem !important;
}

#loan .loan-cart-row {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

/* —— تسهیلات خودم (هم‌سبک حساب‌های خودم) —— */
#loan .loan-own-body {
  padding: 0.15rem 0.15rem 0.35rem;
}

#loan .loan-own-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

#loan .loan-own-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.9rem;
}

#loan .loan-own-card-col {
  min-width: 0;
}

#loan .loan-own-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem 1.05rem 0.95rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

#loan .loan-own-card__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #e8eef2;
}

#loan .loan-own-card__tools {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

#loan .loan-own-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  color: #56508d;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #f8fafc;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
  text-decoration: none;
}

#loan .loan-own-icon-btn:hover,
#loan .loan-own-icon-btn:focus {
  color: #287db4;
  border-color: rgba(40, 125, 180, 0.28);
  background: #edf5fb;
  outline: none;
  text-decoration: none;
}

#loan .loan-own-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

#loan .loan-own-field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

#loan .loan-own-field__label {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

#loan .loan-own-field__value {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  word-break: break-word;
}

#loan .loan-own-field--danger .loan-own-field__label,
#loan .loan-own-field--danger .loan-own-field__value {
  color: #b44f46;
}

#loan .loan-own-balance {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-top: auto;
  padding: 0.75rem 0.85rem;
  border-radius: 12px;
  background: linear-gradient(110deg, #edf7fb, #f4eef8);
}

#loan .loan-own-balance__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

#loan .loan-own-balance__label {
  color: #56508d;
  font-size: 12px;
  font-weight: 800;
}

#loan .loan-own-balance__value {
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  text-align: left;
}

#loan .loan-own-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
  margin-top: 0.8rem;
}

#loan .loan-own-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 0.3rem 0.75rem;
  border: 1px solid;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(41, 52, 95, 0.05);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
}

#loan .loan-own-actions .loan-own-chip {
  flex: 1 1 5.5rem;
}

#loan .loan-own-chip:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#loan .loan-own-chip--deposit {
  color: #2f7a1f;
  border-color: #b7dfb0;
  background: #eef8ec;
}

#loan .loan-own-chip--deposit:hover,
#loan .loan-own-chip--deposit:focus {
  color: #fff;
  border-color: #2f7a1f;
  background: #2f7a1f;
  text-decoration: none;
}

#loan .loan-own-chip--deposit.disabled,
#loan .loan-own-chip--ghost.disabled {
  color: #8a96a3;
  border-color: #e8eef2;
  background: #f4f6f8;
  cursor: not-allowed;
  pointer-events: none;
  box-shadow: none;
}

#loan .loan-own-chip--withdraw {
  color: #b44f46;
  border-color: #f0d4d1;
  background: #fcefed;
}

#loan .loan-own-chip--withdraw:hover,
#loan .loan-own-chip--withdraw:focus {
  color: #fff;
  border-color: #b44f46;
  background: #b44f46;
  text-decoration: none;
}

#loan .loan-own-chip--turn {
  color: #8a6414;
  border-color: #eed9b0;
  background: #fff4d6;
}

#loan .loan-own-chip--ghost {
  color: #56508d;
  border-color: rgba(86, 80, 141, 0.28);
  background: #f4eef8;
}

#loan .loan-own-chip--turn:hover,
#loan .loan-own-chip--turn:focus {
  color: #fff;
  border-color: #c48726;
  background: #c48726;
  text-decoration: none;
}

#loan .loan-own-chip--ghost:hover,
#loan .loan-own-chip--ghost:focus {
  color: #fff;
  border-color: #56508d;
  background: #56508d;
  text-decoration: none;
}

#loan .loan-own-chip--info {
  color: #287db4;
  border-color: #cfe4f2;
  background: #edf5fb;
}

#loan .loan-own-chip--info:hover,
#loan .loan-own-chip--info:focus {
  color: #fff;
  border-color: #287db4;
  background: #287db4;
  text-decoration: none;
}

#loan .loan-own-chip--muted {
  color: #6b7b8e;
  border-color: #dbe5eb;
  background: #f8fafc;
}

#loan .loan-own-chip--muted:hover,
#loan .loan-own-chip--muted:focus {
  color: #29345f;
  border-color: #bdcbd4;
  background: #fff;
}

#loan .loan-own-empty {
  padding: 1.25rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

#loan .loan-own-list {
  margin-top: 0.25rem;
}

#loan .loan-own-list-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}

#loan .loan-own-list .vbt-table-wrapper td {
  vertical-align: middle;
}

@media (max-width: 1199px) {
  #loan .loan-own-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  #loan .loan-own-grid {
    grid-template-columns: 1fr;
  }

  #loan .loan-own-actions .loan-own-chip {
    flex: 1 1 100%;
  }
}

#loan .account-cards-grid {
  margin-left: -10px;
  margin-right: -10px;
  row-gap: 4px;
}

#loan .account-card-col {
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 12px;
}

#loan .costom-card .border-bottom > .col-12 > hr,
#loan .costom-card-sahebanhesab .border-bottom > .col-12 > hr {
  margin-top: 0.35rem;
  margin-bottom: 0.25rem;
}

#loan .account-card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 24px;
}

#loan .account-card-toolbar__start,
#loan .account-card-toolbar__end {
  display: flex;
  align-items: center;
  gap: 8px;
}

#loan .account-card-share {
  border: 0;
  background: transparent;
  color: #6c757d;
  padding: 0 2px;
  line-height: 1;
  font-size: 15px;
  cursor: pointer;
}

#loan .account-card-share:hover,
#loan .account-card-share:focus {
  color: #435ebe;
  outline: none;
}

#loan .account-card-body-main {
  padding-top: 0;
  margin-top: 0;
}

#loan .account-card-fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-top: 0;
  margin-bottom: 0.65rem;
  padding-top: 0;
}

#loan .account-card-field-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  text-align: right;
}

#loan .account-card-field-row__label {
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
  color: #495057;
}

#loan .account-card-field-row__value {
  text-align: left;
  word-break: break-word;
  min-width: 0;
}

#loan .account-card-balance-footer {
  margin: 0;
  padding: 6px 0 10px;
  border-top: 1px solid #e8ecf1;
}

#loan .account-card-balance-block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: right;
  padding: 0;
  margin: 0;
}

#loan .account-card-balance-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  margin-bottom: 0;
  text-align: right;
}

#loan .account-card-balance-row__label {
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
  color: #495057;
}

#loan .account-card-balance-row__value {
  text-align: left;
  word-break: break-word;
  min-width: 0;
}

#loan .account-card-actions {
  margin-left: 0;
  margin-right: 0;
  row-gap: 8px;
}

#loan .account-card-actions > [class*="col-"] {
  flex: 0 0 100%;
  max-width: 100%;
  padding-left: 0;
  padding-right: 0;
}

#loan .btn-outline-success.NetPa-btn {
  color: #55941a;
  background-color: #fff;
  border-color: #5ea31e;
  font-weight: 600;
}

#loan .btn-outline-success.NetPa-btn:hover,
#loan .btn-outline-success.NetPa-btn:focus {
  color: #fff !important;
  background-color: #55941a !important;
  border-color: #55941a !important;
}

#loan .loan-cardex-btn {
  color: #56508d !important;
  border: 1px solid rgba(86, 80, 141, 0.28) !important;
  background-color: #f4eef8 !important;
  font-weight: 600;
}

#loan .loan-cardex-btn:hover:not(.disabled) {
  color: #fff !important;
  background-color: #56508d !important;
  border-color: #56508d !important;
}

#loan a.loan-cardex-btn.disabled {
  color: #8a8a8a !important;
  border-color: #ccc !important;
  background-color: #f5f5f5 !important;
  opacity: 1;
}

#loan #Modal-Mobile:has(.netpa-account-detail-modal) .modal-dialog {
  margin: 1.25rem auto;
  max-width: 640px;
  width: calc(100% - 2.5rem);
}

#loan #Modal-Mobile:has(.netpa-account-detail-modal) .modal-content {
  background: #fff !important;
  border: none;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(42, 63, 84, 0.18);
  overflow: hidden;
  width: 100%;
  max-height: calc(100vh - 2.5rem);
}

#loan #Modal-Mobile:has(.netpa-account-detail-modal) .modal-body {
  padding: 0;
  position: relative;
}

#loan #Modal-Mobile:has(.netpa-account-detail-modal) .close {
  position: absolute;
  top: 0.85rem;
  left: 0.85rem;
  z-index: 2;
  float: none;
  margin: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(42, 63, 84, 0.08);
  color: #2a3f54 !important;
  opacity: 1;
  text-shadow: none;
  font-size: 1.35rem;
  line-height: 1;
}

#loan #Modal-Mobile:has(.netpa-account-detail-modal) .close:hover {
  background: rgba(42, 63, 84, 0.14);
  color: #1a2a3a !important;
}

#loan .netpa-account-detail-modal__panel {
  background: #fff;
  padding: 1rem 1.15rem 1.25rem;
  text-align: right;
}

#loan .netpa-account-detail-modal__header {
  margin-bottom: 0.85rem;
  padding-bottom: 0;
  padding-left: 2.5rem;
}

#loan .netpa-account-detail-modal__title {
  margin: 0;
  font-size: 15px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

#loan .netpa-account-detail-modal__title .fa-info-circle {
  color: #435ebe;
}

#loan .netpa-account-detail-modal__header-divider {
  margin: 0.75rem 0;
  border: 0;
  border-top: 1px solid #e8ecf1;
  opacity: 1;
}

#loan .netpa-account-detail-modal__account-type {
  margin: 0;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e8ecf1;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  line-height: 1.5;
}

#loan .netpa-account-detail-modal__account-type .fa-money-check {
  color: #28a745;
}

#loan .netpa-account-detail-modal__grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
}

#loan .netpa-account-detail-modal__item {
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 0.5rem 0.65rem;
  border-radius: 8px;
  background: #f8f9fb;
}

#loan .netpa-account-detail-modal__label {
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  white-space: nowrap;
  flex-shrink: 0;
  text-align: right;
}

#loan .netpa-account-detail-modal__value {
  font-size: 14px;
  font-weight: 700;
  color: #2a3f54;
  word-break: break-word;
  text-align: left;
  flex: 0 1 auto;
  min-width: 0;
}

#loan .netpa-account-detail-modal__section-title {
  margin: 0.15rem 0 0.65rem;
  padding-top: 0.55rem;
  border-top: 1px solid #e8ecf1;
  font-size: 14px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

#loan .netpa-account-detail-modal__score {
  margin-top: 0.75rem;
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  background: #f0f4ff;
  border: 1px solid rgba(67, 94, 190, 0.15);
  text-align: center;
}

#loan .netpa-account-detail-modal__score-note {
  margin: 0.35rem 0 0;
  font-size: 14px;
  color: #2a3f54;
  line-height: 1.6;
}

#loan .netpa-account-detail-modal__score-note strong {
  color: #d97706;
  font-weight: 700;
}

@media (max-width: 767px) {
  #loan #Modal-Mobile:has(.netpa-account-detail-modal) .modal-dialog {
    margin: 1rem auto;
    width: calc(100% - 2rem);
    max-width: calc(100% - 2rem);
  }

  #loan #Modal-Mobile:has(.netpa-account-detail-modal) .modal-content {
    border-radius: 16px;
    max-height: calc(100vh - 2rem);
  }

  #loan .netpa-account-detail-modal__panel {
    padding: 0.9rem 1rem 1.1rem;
  }

  #loan .netpa-account-detail-modal__header {
    padding-left: 2.25rem;
  }

  #loan .netpa-account-detail-modal__label {
    white-space: normal;
  }
}

#loan #ModalBanafash .modal-dialog {
  margin: 1.25rem auto;
  max-width: min(960px, calc(100vw - 2rem));
  width: calc(100% - 2rem);
}

#loan #ModalBanafash .modal-content {
  background: #fff !important;
  border: none;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(42, 63, 84, 0.18);
  overflow: hidden;
  max-height: calc(100vh - 2.5rem);
}

#loan #ModalBanafash .modal-header.bg {
  display: none;
}

#loan #ModalBanafash .modal-body {
  padding: 0;
  position: relative;
  max-height: calc(100vh - 2.5rem);
  overflow-y: auto;
}

#loan #ModalBanafash .loan-cardex-modal__header {
  padding-left: 2.75rem;
}

@media (max-width: 767px) {
  #loan #ModalBanafash .modal-dialog {
    margin: 1rem auto;
    width: calc(100% - 1rem);
    max-width: calc(100% - 1rem);
  }

  #loan #ModalBanafash .modal-content {
    border-radius: 16px;
    max-height: calc(100vh - 2rem);
  }

  #loan #ModalBanafash .modal-body {
    max-height: calc(100vh - 2rem);
  }
}
</style>
